module.exports = {
        srcSet: __webpack_public_path__ + "app_stores_banner_google_AZ-1550-d72ea89d329526fb.digested.png"+" 1550w",
        images: [{path: __webpack_public_path__ + "app_stores_banner_google_AZ-1550-d72ea89d329526fb.digested.png",width: 1550,height: 600}],
        src: __webpack_public_path__ + "app_stores_banner_google_AZ-1550-d72ea89d329526fb.digested.png",
        toString: function(){return __webpack_public_path__ + "app_stores_banner_google_AZ-1550-d72ea89d329526fb.digested.png"},
        
        width: 1550,
        height: 600
      }